// src/App.js
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Dashboard from "./Dashboard";
import CreateCourse from "./CreateCourse";
import EditCourse from "./EditCourse";
import Learners from "./Learners";
import LearnerDetails from "./LearnerDetail";
import InsightsPage from "./Insights";
import SettingsPage from "./Settings";
import LoginModal from "./LoginModal";
import LessonAnalyzePage from "./LessonAnalyzePage";
import ArchiveCourse from "./ArchiveCourse";
import TermsOfUse from "./legal/TermsOfUse";
import KvkkPrivacyPolicy from "./legal/KvkkPrivacyPolicy";
import AydinlatmaMetni from "./legal/AydinlatmaMetni";
import Archive from "./Archive";
import Broadcast from "./Broadcast";
import ForceSend from "./ForceSend";

// Simple ProtectedRoute component
function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token");

  if (!token) {
    // Eğer token yoksa, login sayfasına yönlendir
    return <Navigate to="/" replace />;
  }

  return children;
}

function App() {
  return (
    /* Wrap the app with AuthProvider to provide auth context */
    //<AuthProvider>
    <Router>
      <Routes>
        {/* Public route - Login */}
        <Route path="/" element={<LoginModal />} />

        {/* Protected routes - Only accessible when logged in */}
        <Route
          path="/:userId/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:userId/create-course"
          element={
            <ProtectedRoute>
              <CreateCourse />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:userId/learners"
          element={
            <ProtectedRoute>
              <Learners />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:userId/learners/:id/details"
          element={
            <ProtectedRoute>
              <LearnerDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:userId/insights"
          element={
            <ProtectedRoute>
              <InsightsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:userId/settings"
          element={
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:userId/edit-course/:courseId"
          element={
            <ProtectedRoute>
              <EditCourse />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:userId/archive-course/:courseId"
          element={
            <ProtectedRoute>
              <Archive />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:userId/broadcast"
          element={
            <ProtectedRoute>
              <Broadcast />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:userId/force-send"
          element={
            <ProtectedRoute>
              <ForceSend />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:userId/archive"
          element={
            <ProtectedRoute>
              <Archive />
            </ProtectedRoute>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route path="/lesson-analyze/:slug" element={<LessonAnalyzePage />} />
        <Route path="/terms" element={<TermsOfUse />} />
        <Route path="/kvkk-privacy" element={<KvkkPrivacyPolicy />} />
        <Route path="/aydinlatma-metni" element={<AydinlatmaMetni />} />
      </Routes>
    </Router>
    //</AuthProvider>
  );
}

export default App;
